import { createFileRoute } from "@tanstack/react-router";
import { Require } from "../features/require";
import { SubscriptionPage } from "../features/subscription/subscription-page";

/** More > Subscription (P10-T16), owners only. */
export const Route = createFileRoute("/more/subscription")({ component: Page });

function Page() {
	return (
		<Require permission="subscription.view">
			<SubscriptionPage />
		</Require>
	);
}
